import { FormikPaymentType } from 'components/Molecules/Payments/CreatePaymentDrawer/formData';
import { FormikProps } from 'formik';
import t from 'utils/translationHelper';
import * as yup from 'yup';

import { DrawdownFundingMethod, DrawdownSubmissionRequest } from '@alpha/fx-dtos';

type Drawdown = {
    tradeId: string;
    valueDate: string | null;
    fixCurrencyCode: string;
    amount: number | null;
    fundingMethod: DrawdownFundingMethod;
    sellCurrencyCode: string;
    buyCurrencyCode: string;
    rate: number;
    massDrawdownId?: string;
};

export type MassDrawdownRequestForm = {
  drawdowns: Drawdown[];
  currencyPair: string,
  totalDrawdownAmount: number,
  weightedRate: number,
  valueDate: string,
  sellCurrencyCode: string,
  buyCurrencyCode: string,
  splitType: string;
  evenSplitAmount: number | null;
  fundingMethod: DrawdownFundingMethod;
  fixCurrencyCode: string;
};

export const initialValues: MassDrawdownRequestForm = {
  drawdowns: [{
    tradeId: '',
    valueDate: null,
    fixCurrencyCode: '',
    amount: null,
    fundingMethod: DrawdownFundingMethod.CURRENCY_ACCOUNT_BALANCE,
    sellCurrencyCode: '',
    buyCurrencyCode: '',
    rate: 0,
    massDrawdownId: '',
  }],
  currencyPair: '',
  splitType: 'placeholder',
  totalDrawdownAmount: 0,
  evenSplitAmount: null,
  weightedRate: 0,
  valueDate: '',
  sellCurrencyCode: '',
  buyCurrencyCode: '',
  fundingMethod: DrawdownFundingMethod.CURRENCY_ACCOUNT_BALANCE,
  fixCurrencyCode: 'placeholder',
};

export type FormikValueProps = FormikProps<FormikType>;
export type FormikType = {
  payments?: FormikPaymentType[];
}

export const drawdownSubmissionInitialValues: DrawdownSubmissionRequest = {
  paymentIds: [],
  dynamicLinkingId: '',
};

export const formValidation = {
  valueDate: yup.string().required(t('please_specify_a_value_date')),
  splitType: yup.string()
    .required(t('please_select_a_split_type'))
    .notOneOf(['placeholder'], t('please_select_a_valid_split_type')),
  fixCurrencyCode: yup.string().required(t('please_select_a_currency')),
  evenSplitAmount: yup.number().when('splitType', {
    is: 'split-evenly',
    then: (schema: any) => schema.positive(t('please_enter_a_positive_amount')).required(t('please_enter_an_amount')),
    otherwise: (schema: any) => schema.nullable(),
  }),
  drawdowns: yup.array().of(yup.object().shape({
    amount: yup.number().required(t('please_enter_an_amount')),
  })),
};

export const submissionformValidation = {
  paymentIds: yup.array().typeError(t('please_enter_an_id_array')),
  drawdownIds: yup.array().required(t('')).typeError(t('please_enter_an_id_array')),
};
